import { Action } from 'redux';
import { IDocumentBlob } from '../../types';
import {
  IDownloadStoreDocumentBlobParams,
  downloadStoreDocumentAdminBlob,
  IDownloadStoreDocumentBlobResponse,
} from '../../api/StoreDocuments/downloadStoreDocumentAdminBlobApi';
import { AxiosResponse } from 'axios';

export const GET_STORE_DOCUMENT_BLOB_REQUEST = 'GET_STORE_DOCUMENT_BLOB_REQUEST';
export const GET_STORE_DOCUMENT_BLOB_RESPONSE = 'GET_STORE_DOCUMENT_BLOB_RESPONSE';
export const GET_STORE_DOCUMENT_BLOB_ERROR = 'GET_STORE_DOCUMENT_BLOB_ERROR';

export const downloadStoreDocumentAdminBlobRequest = (parameters: IDownloadStoreDocumentBlobParams,
  onSuccess: (data: IDocumentBlob) => void,
  onFailure: () => void): any => {
  return (dispatch: any) => {
    dispatch({
      type: GET_STORE_DOCUMENT_BLOB_REQUEST,
    });

    return downloadStoreDocumentAdminBlob(parameters)
      .then((response: AxiosResponse<IDownloadStoreDocumentBlobResponse>) => {
        if (response.status === 200) {
          dispatch({
            type: GET_STORE_DOCUMENT_BLOB_RESPONSE,
            response: response.data.document,
          });
          onSuccess(response.data.document);
        } else {
          onError(dispatch);
          onFailure();
        }
      })
      .catch((err: any) => {
        console.log(err);
        onError(dispatch);
        onFailure();
      });
  };
};

const onError = (dispatch: any) => dispatch({
  type: GET_STORE_DOCUMENT_BLOB_ERROR,
});
